import { useEffect, useState } from "react";

// Renders the scripted 1-2 turn warm welcome from the backend BEFORE any
// real Anthropic call fires. Zero wallet impact — the text is hand-written
// and served by /api/sage/first-turn-script. When the visitor sends their
// first real message, this component is unmounted and the stream takes over.
export default function FirstTurnWelcome() {
  const [script, setScript] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const backend = process.env.REACT_APP_BACKEND_URL;
    fetch(`${backend}/api/sage/first-turn-script`)
      .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
      .then(setScript)
      .catch(() => setFailed(true));
  }, []);

  if (failed || !script) return null;

  return (
    <div className="space-y-4 mb-6" data-testid="first-turn-welcome">
      {script.turns.map((t, i) => (
        <div key={i} className="border-l-2 border-sage-accent pl-4" data-testid={`first-turn-bubble-${i}`}>
          <div className="text-[10px] uppercase tracking-[0.2em] text-sage-muted mb-2">
            Sage · scripted · $0.00
          </div>
          <div className="text-sage-text whitespace-pre-wrap leading-relaxed">{t.text}</div>
        </div>
      ))}
      <div className="text-[10px] uppercase tracking-[0.2em] text-sage-faint pl-4">
        {script.audit_note}
      </div>
    </div>
  );
}
